import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserDeviceVm } from '../platform-user-device-vm.model';

@Injectable({ providedIn: 'root' })
export class PlatformUserDevicesService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserDevices`;
  }

  get(userGuid: string): Observable<IPlatformUserDeviceVm[]> {
    const headers = this.createHeaders();
    const params = new HttpParams().set('userGuid', userGuid);
    return this.http.get<IPlatformUserDeviceVm[]>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
